import React from 'react';

const Cargando = ({height}) => {
    const h = height ? height : '300px';
    return (
        <div style={{ height: h, display:'flex', justifyContent:'center', alignItems: 'center' }}>
            <div style={{ width: '35px', height: '35px', background: 'url(/img/cargando.gif)' }}></div>
        </div>
    )
}

export default Cargando;